<template>
  <div class="card">
    <div class="card-header" v-if="!preselected">SMS</div>
    <div class="card-body">
      <div v-if="step === 'composing'">
        <div v-if="selectedTemplate">
          <div v-if="!preselected">
            <div class="emails-header">
              <div class="mr-2">{{ selectedTemplate.title }}</div>
              <button class="btn btn-secondary btn-sm" @click="selectTemplate(null)">Change template</button>
            </div>
            <LoadingIndicator v-if="loadingSmsPreview" centered />
            <div v-else>
              <ValidatedInput label="To" id="to" v-model="phone" mask="phone"/>
              <ValidatedInput label="Text" type="textarea" id="text" v-model="text" />
              <div class="d-flex justify-content-end pt-4">
                <button class="btn btn-primary" @click="sendSms">Send SMS</button>
              </div>
            </div>
          </div>
          <div v-else>
            <p>
              Are you sure you want to send <b>{{ selectedTemplate.title }}</b> to the customer?
            </p>
            <div class="d-flex justify-content-end pt-4">
              <button class="btn btn-warning" @click="$emit('clickclose')">No</button>
              <button class="btn btn-primary ml-2" @click="sendSms">Yes</button>
            </div>
          </div>
        </div>
        <div v-else>
          <h4>Select SMS template</h4>
          <LoadingIndicator v-if="loadingTemplate" centered />
          <ul v-else class="list-group">
            <li v-for="template in templates" :key="template.id" class="list-group-item list-group-item-action" @click="selectTemplate(template.id)">
              {{ template.title }}
            </li>
          </ul>
        </div>
      </div>
      <div v-if="step === 'sending'">
        <div class="status-message">
          <h2>Sending SMS...</h2>
          <LoadingIndicator centered />
        </div>
      </div>
      <div v-if="step === 'sent'">
        <div class="status-message">
          <h2><i class="far fa-envelope mr-2"></i> SMS sent!</h2>
          <button class="btn btn-primary" @click="newSms">Send another SMS</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { ApiClient } from '@/api/ApiClient';
import ValidatedInput from '@/components/shared/ValidatedInput';
import LoadingIndicator from '@/components/shared/LoadingIndicator';

export default {
  name: 'LeadlikeSmss',
  props: {
    leadQuoteOrder: {
      type: Object,
      default: () => ({}),
    },
    selected: {
      type: String,
      default: null,
    },
    preselected: {
      type: String,
      default: null,
    },
  },
  components: { ValidatedInput, LoadingIndicator },
  data() {
    return {
      loadingTemplate: false,
      loadingSmsPreview: false,
      step: 'composing',
      selectedTemplateId: null,
      phone: '',
      text: '',
    };
  },
  computed: {
    selectedTemplate() {
      return this.templates.find(t => t.id == this.selectedTemplateId);
    },
    templates() {
      return this.$store.getters['leads/getSmsTemplates'](this.leadQuoteOrder.leadTypeId);
    },
  },
  async created() {
    if (this.selected) {
      let template = this.templates.find(t => t.name == this.selected);
      if (template) this.selectTemplate(template.id);
    }
  },
  methods: {
    async selectTemplate(id) {
      this.selectedTemplateId = id;
      if (this.selectedTemplateId) {
        this.loadingSmsPreview = true;
        const response = await ApiClient.smsTemplates.preview.get({
          id: this.selectedTemplateId,
          leadId: this.leadQuoteOrder.id,
        });
        this.loadingSmsPreview = false;
        const data = response.data.data;
        if (data) {
          this.phone = data.phone;
          this.text = data.text;
        }
      }
    },
    async sendSms() {
      this.step = 'sending';
      const response = await ApiClient.sms.post({
        body: {
          leadId: this.leadQuoteOrder.id,
          phone: this.phone,
          text: this.text,
        },
      });
      if (response.status === 200) {
        this.step = 'sent';
        this.$emit('resetModal');
      } else {
        this.step = 'composing';
      }
    },
    newSms() {
      this.step = 'composing';
      this.selectedTemplateId = null;
    },
  },
  mounted() {
    if (this.preselected) {
      let template = this.templates.find(t => t.name == this.preselected);
      if (template) this.selectTemplate(template.id);
    }
  },
};
</script>

<style lang="scss" scoped>
h2 {
  display: flex;
  align-items: center;
}
.emails-header {
  display: flex;
  align-items: center;
  font-size: 24px;
  font-weight: bold;
  margin-bottom: 1em;
}
.list-group-item-action {
  cursor: pointer;
}
.status-message {
  display: flex;
  padding: 32px;
  flex-direction: column;
  align-items: center;
}
</style>
